import { PiDownloadSimple } from 'react-icons/pi';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { useFileDownloadUrl } from 'src/modules/shared/hooks/api/custom-fields/files';
import {
  type ComponentAppearance,
  type ComponentSize,
  type ComponentVariant,
} from 'src/modules/shared/types/component.type';
import { Typography } from '@material-tailwind/react';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';
import { formatFileSize } from 'src/modules/shared/utils/formatting/file.util';

interface FileDownloadButtonProps {
  fileId: string;
  size?: ComponentSize;
  variant?: ComponentVariant;
  appearance?: ComponentAppearance;
  className?: string;
  filename?: string;
  fileSize?: number;
}

export const FileDownloadButton: React.FC<FileDownloadButtonProps> = ({
  fileId,
  size = 'sm',
  variant = 'primary',
  appearance = 'outline',
  className,
  filename,
  fileSize,
}) => {
  const { downloadUrl, loading } = useFileDownloadUrl({
    fileId,
    enabled: !!fileId,
  });

  const handleDownload = () => {
    if (!downloadUrl) return;

    window.open(downloadUrl, '_blank');
  };
  const tooltipContent =
    filename && fileSize ? (
      <div>
        <Typography className="font-medium text-sm">
          {/* TODO: check when implementing i18n */}
          Descarga {filename}
        </Typography>

        {fileSize && (
          <Typography className="text-xs text-secondary-500">
            {formatFileSize(fileSize)}
          </Typography>
        )}
      </div>
    ) : null;

  return (
    <Tooltip content={tooltipContent} placement="top" size="sm">
      <Button
        size={size}
        variant={variant}
        appearance={appearance}
        onClick={handleDownload}
        disabled={!downloadUrl || loading}
        loading={loading}
        className={className}
      >
        <div className="flex items-center gap-2">
          <PiDownloadSimple className="h-4 w-4" />

          {filename && (
            <Typography
              className="truncate max-w-[100px] text-xs font-medium"
              title={filename}
            >
              {filename}
            </Typography>
          )}
        </div>
      </Button>
    </Tooltip>
  );
};
